export const LK_NOTIFICATION_ROLES = [
  'admin',
  'admin-engineer',
  'manager',
  'call-center',
  'analytics',
  'master',
  'checkpoint-admin',
  'management_company',
];

export const LK_NOTIFICATION_ROLE_OPTIONS = [
  { text: 'Администратор', value: 'admin' },
  { text: 'Админ-инженер', value: 'admin-engineer' },
  { text: 'Менеджер', value: 'manager' },
  { text: 'Кол-центр', value: 'call-center' },
  { text: 'Аналитик', value: 'analytics' },
  { text: 'Мастер', value: 'master' },
  { text: 'Администратор КПП', value: 'checkpoint-admin' },
  { text: 'Управляющая компания', value: 'management_company' },
];

export const LK_NOTIFICATION_TYPE_OPTIONS = [
  {
    value: 'feature',
    text: 'Новая функция',
    description: 'Релизы и новые возможности системы',
    icon: 'mdi-star-circle-outline',
    iconColor: '#FF8F00',
    chipColor: 'amber accent-4',
    avatarBg: 'rgba(255, 171, 0, 0.38)',
    avatarBorder: '#FFB300',
    unreadGradient: 'linear-gradient(90deg, rgba(255, 171, 0, 0.16) 0%, rgba(255, 248, 225, 0.28) 55%, rgba(255, 255, 255, 0) 100%)',
  },
  {
    value: 'fix',
    text: 'Исправление',
    description: 'Исправления ошибок и доработки',
    icon: 'mdi-wrench-outline',
    iconColor: '#1E88E5',
    chipColor: 'light-blue accent-4',
    avatarBg: 'rgba(30, 136, 229, 0.35)',
    avatarBorder: '#42A5F5',
    unreadGradient: 'linear-gradient(90deg, rgba(30, 136, 229, 0.15) 0%, rgba(227, 242, 253, 0.3) 55%, rgba(255, 255, 255, 0) 100%)',
  },
  {
    value: 'info',
    text: 'Информация',
    description: 'Общие сообщения и напоминания',
    icon: 'mdi-information-outline',
    iconColor: '#00ACC1',
    chipColor: 'cyan accent-4',
    avatarBg: 'rgba(0, 172, 193, 0.35)',
    avatarBorder: '#26C6DA',
    unreadGradient: 'linear-gradient(90deg, rgba(0, 172, 193, 0.15) 0%, rgba(224, 247, 250, 0.3) 55%, rgba(255, 255, 255, 0) 100%)',
  },
  {
    value: 'warning',
    text: 'Важно',
    description: 'Срочные или критичные уведомления',
    icon: 'mdi-alert-circle-outline',
    iconColor: '#F4511E',
    chipColor: 'deep-orange accent-4',
    avatarBg: 'rgba(244, 81, 30, 0.32)',
    avatarBorder: '#FF7043',
    unreadGradient: 'linear-gradient(90deg, rgba(244, 81, 30, 0.14) 0%, rgba(255, 243, 224, 0.3) 55%, rgba(255, 255, 255, 0) 100%)',
  },
  {
    value: 'update',
    text: 'Обновление',
    description: 'Изменения в работе сервиса',
    icon: 'mdi-update',
    iconColor: '#5E35B1',
    chipColor: 'deep-purple accent-2',
    avatarBg: 'rgba(94, 53, 177, 0.32)',
    avatarBorder: '#7E57C2',
    unreadGradient: 'linear-gradient(90deg, rgba(94, 53, 177, 0.14) 0%, rgba(237, 231, 246, 0.3) 55%, rgba(255, 255, 255, 0) 100%)',
  },
];

const TYPE_BY_VALUE = LK_NOTIFICATION_TYPE_OPTIONS.reduce((acc, item) => {
  acc[item.value] = item;
  return acc;
}, {});

const DEFAULT_TYPE_STYLE = {
  iconColor: '#FFC107',
  chipColor: 'amber accent-4',
  avatarBg: 'rgba(255, 193, 7, 0.32)',
  avatarBorder: '#FFD54F',
  unreadGradient: 'linear-gradient(90deg, rgba(255, 193, 7, 0.15) 0%, rgba(255, 248, 225, 0.28) 55%, rgba(255, 255, 255, 0) 100%)',
};

export function getNotificationTypeOption (type) {
  return TYPE_BY_VALUE[type] || null;
}

export function getNotificationTypeIcon (type) {
  return getNotificationTypeOption(type)?.icon || 'mdi-bell-outline';
}

/** Яркий цвет иконки (hex). */
export function getNotificationTypeColor (type) {
  return getNotificationTypeOption(type)?.iconColor || DEFAULT_TYPE_STYLE.iconColor;
}

/** Цвет чипа Vuetify. */
export function getNotificationTypeChipColor (type) {
  return getNotificationTypeOption(type)?.chipColor || DEFAULT_TYPE_STYLE.chipColor;
}

/** Фон аватара в карточке уведомления. */
export function getNotificationTypeAvatarBg (type) {
  return getNotificationTypeOption(type)?.avatarBg || DEFAULT_TYPE_STYLE.avatarBg;
}

/** Рамка аватара. */
export function getNotificationTypeAvatarBorder (type) {
  return getNotificationTypeOption(type)?.avatarBorder || DEFAULT_TYPE_STYLE.avatarBorder;
}

/** Стиль иконки-аватара в карточке (без яркой рамки). */
export function getNotificationTypeAvatarStyle (type) {
  return {
    background: getNotificationTypeAvatarBg(type),
  };
}

/** Фон нового (непрочитанного) уведомления — градиент по типу. */
export function getNotificationTypeUnreadStyle (type) {
  const opt = getNotificationTypeOption(type);
  const gradient = opt?.unreadGradient || DEFAULT_TYPE_STYLE.unreadGradient;

  return {
    background: gradient,
  };
}

export function getNotificationTypeLabel (type) {
  return getNotificationTypeOption(type)?.text || '';
}

export function canViewLkNotifications (roleName) {
  return LK_NOTIFICATION_ROLES.includes(roleName);
}

export function resolveLkNotificationId (item) {
  if (!item) return null;

  const candidates = [
    item.id,
    item.broadcast_id,
  ];

  for (const value of candidates) {
    if (value !== undefined && value !== null && value !== '') {
      return value;
    }
  }

  return null;
}

export function normalizeLkNotificationAdminItem (item) {
  const id = resolveLkNotificationId(item);
  const recipientsCount = item.recipients_count ?? 0;
  const readCount = item.read_count ?? 0;
  const unreadCount = item.unread_count ?? Math.max(0, recipientsCount - readCount);

  return {
    ...item,
    id,
    recipients_count: recipientsCount,
    read_count: readCount,
    unread_count: unreadCount,
  };
}

export function formatBroadcastReadStatus (item) {
  const total = item.recipients_count ?? 0;
  const read = item.read_count ?? 0;
  const unread = item.unread_count ?? Math.max(0, total - read);

  if (total === 0) {
    return 'Нет получателей';
  }
  if (unread === 0) {
    return `Прочитали все (${read})`;
  }
  if (read === 0) {
    return `Не прочитано: ${unread} из ${total}`;
  }
  return `Прочитано ${read} из ${total}`;
}

export function getBroadcastReadStatusColor (item) {
  const total = item.recipients_count ?? 0;
  const unread = item.unread_count ?? Math.max(0, total - (item.read_count ?? 0));

  if (total === 0) {
    return 'grey';
  }
  if (unread === 0) {
    return 'success';
  }
  if ((item.read_count ?? 0) === 0) {
    return 'error';
  }
  return 'orange';
}

/** Рассылка прочитана всеми получателями. */
export function isBroadcastFullyRead (item) {
  const total = item.recipients_count ?? 0;
  if (total === 0) {
    return false;
  }
  const unread = item.unread_count ?? Math.max(0, total - (item.read_count ?? 0));
  return unread === 0;
}
